import React from 'react';
import { Typography, Link } from '@mui/material';
import { WEBSITE_NAME, WEBSITE_LINK } from '../common/AppConstants';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.primary" align="center" {...props}>
      {'© '}
      {new Date().getFullYear()} {WEBSITE_NAME}
      {' - All rights reserved.'}
    </Typography>
  );
}

export default Copyright;
